var _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "scan-loader",
    width: 135,
    height: 60,
    viewBox: "0 0 100 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 10,
    height: 60,
    rx: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60;",
    begin: "0s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    begin: "0s",
    values: "0;20;0;",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 0,
    width: 10,
    height: 60,
    rx: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60",
    begin: "0.2s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    values: "0;20;0",
    begin: "0.2s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 0,
    width: 10,
    height: 60,
    rx: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60",
    begin: "0.4s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    values: "0;20;0",
    begin: "0.4s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 0,
    width: 10,
    height: 60,
    rx: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60",
    begin: "0.6s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    values: "0;20;0",
    begin: "0.6s",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 0,
    width: 10,
    height: 60,
    rx: 6
  }, /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "height",
    values: "60;20;60",
    begin: "0.8s",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeType: "CSS",
    attributeName: "y",
    values: "0;20;0",
    begin: "0.8s",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanLoader);
export default __webpack_public_path__ + "static/media/scan-loader.f3a9a03d726f5dc7ea09b5331673400d.svg";
export { ForwardRef as ReactComponent };